import TransactionService from "../services/transaction.service";

const state = {
	transactions: [],
	total: 0,
	columns: [
		{
			key: 'id',
			label: 'ID',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'comment',
			label: 'transaction.comment',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'type',
			label: 'transaction.type',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'responsibleId',
			label: 'transaction.responsibleId',
			'class': 'td-20',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'responsibleName',
			label: 'transaction.responsibleName',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'contractId',
			label: 'transaction.contractId',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'contragentId',
			label: 'transaction.contragentId',
			'class': 'td-20',
			sortable: true,
			visible: false,
			changebale: true,
		},
		{
			key: 'contragentName',
			label: 'transaction.contragentName',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'priceUsd',
			label: 'transaction.priceUsd',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'priceUzs',
			label: 'transaction.priceUzs',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'transactionDate',
			label: 'transaction.transactionDate',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'actions',
			label: 'goods.actions',
			'class': 'table_actions',
			visible: true,
			changebale: false
		}

	]
};


const getters = {
	columns: (state) => {
		return state.columns
	},

	getAllTransactions: (state) =>{
		return state.transactions
	},
	getTotal: (state) => {
		return state.total
	}

};


const actions = {
	async allTransactions({commit},payload){
		TransactionService.search(payload).then(response => {
			commit('setTransaction', response.data.items);
			commit('setTotal', response.data.total);
		})
	},
	async createOrUpdateTransaction({commit},payload){
		TransactionService.createOrUpdate(payload)
	},
	async deleteTransaction({commit},payload) {
		TransactionService.deleteTransaction(payload)
	}
};

const mutations = {
	setTransaction: (state, payload)=> {
		state.transactions = payload
	},
	setTotal: (state,payload) => {
		state.total = payload
	}
};

export const transaction = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
